import styled from "@emotion/styled";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Collapse,
  IconButton,
} from "@mui/material";
import { useQuestions } from "@natklok/hooks/useQuestions";
import React from "react";
import { FaDownload } from "react-icons/fa";
import { MdExpandMore } from "react-icons/md";

function Translations() {
  const { data: questionsData } = useQuestions();

  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <div>
      <h1>Translations</h1>
      <Card sx={{ maxWidth: 345 }}>
        <CardHeader title="Questions" subheader={`${questionsData?.length} questions`} />
        <CardContent></CardContent>
        <CardActions disableSpacing>
          <IconButton aria-label="add to favorites">
            <FaDownload />
          </IconButton>
          <IconButton onClick={handleExpandClick}>
            <MdExpandMore />
          </IconButton>
        </CardActions>
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <CardContent>Test</CardContent>
        </Collapse>
      </Card>
    </div>
  );
}
export default Translations;
